module.exports = __webpack_public_path__ + "static/chicken-floss-e171e6d373cbe33704197b85ea581a6f.jpg";